import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Sidebar from "./components/common/sidebar";
import Relays from "./page/relays";
import RoutesPage from "./page/routesPage";
import Suppliers from "./page/suppliers";
import Plants from "./page/plants";
import Terminals from "./page/terminals";
import MeetingPoints from "./page/meetingPoints";
import Login from "./auth/login";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    setIsAuthenticated(!!token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  return (
    <div>
      <BrowserRouter>
        <div style={{ display: isAuthenticated ? "flex" : "" }}>
          {isAuthenticated && <Sidebar />}
          <div className={isAuthenticated ? "app" : ""}>
            <Routes>
              {isAuthenticated ? (
                <>
                  <Route path="/" element={<Navigate to="/routes" />} />
                  <Route path="/relays" element={<Relays />}></Route>
                  <Route path="/routes" element={<RoutesPage />}></Route>
                  <Route path="/suppliers" element={<Suppliers />}></Route>
                  <Route path="/plants" element={<Plants />}></Route>
                  <Route path="/terminals" element={<Terminals />}></Route>
                  <Route
                    path="/meetingPoints"
                    element={<MeetingPoints />}
                  ></Route>
                </>
              ) : (
                <Route path="*" element={<Navigate to="/login" />} />
              )}

              {/* <Route path="/login" element={<Login />} /> */}
              <Route
                path="/login"
                element={
                  isAuthenticated ? <Navigate to="/routes" /> : <Login />
                }
              />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
